import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {CommonConstant, FacebookAuthPreviousState} from '../../app.constants';
import {AuthService} from '../auth.service';

@Component({
  selector: 'fb-auth-success-deligator',
  templateUrl: './fb-auth-success-deligator.component.html',
  styleUrls: ['./fb-auth-success-deligator.component.scss']
})
export class FbAuthSuccessDeligatorComponent implements OnInit {

  constructor(private router: Router,
              private auth: AuthService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    const routeState = this.route.snapshot.queryParams.state;
    if (routeState.indexOf(FacebookAuthPreviousState.AUTHENTICATED) >= 0) {
      return this.router.navigate(['dashboard', 'settings'], {
        queryParams: {
          auth_result: 'success'
        }
      });
    } else if (routeState.indexOf(FacebookAuthPreviousState.ON_CAMPAIGN_INVITATION) >= 0) {
      const localAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
      return this.router.navigate(['dashboard', 'campaigns', localAuthData.campaignId, 'new'], {
        queryParams: {
          inviteToken: localAuthData.inviteToken,
          auth_result: 'success',
        }
      });
    } else if (routeState.indexOf(FacebookAuthPreviousState.ON_CONTACT_PERMISSION) >= 0) {
      const localAuthData = this.auth.getInfluencerChannelAuthorizationLocalData();
      return this.router.navigate(['dashboard', 'contact-permission'], {
        queryParams: {
          auth_result: 'success',
          accessToken: localAuthData.accessToken,
          permissionToken: localAuthData.permissionToken
        }
      });
    } else {
      return this.router.navigate(['dashboard', 'details', 'insight'], {
        queryParams: {
          auth_result: 'success',
          accessToken: this.route.snapshot.queryParams.accessToken,
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/fb-auth-success-deligator/fb-auth-success-deligator.component.ts